import {Component, Input} from '@angular/core';
import {MatTableDataSource, MatTableModule} from '@angular/material/table';
import {SplittedCostTableElementV1, SplittedCostTableElementV2} from '../../../../interfaces';
import {CommonModule} from '@angular/common';
import {MatIconModule} from '@angular/material/icon';
import {MatTooltipModule} from '@angular/material/tooltip';


@Component({
  selector: 'app-splitted-costs-table-v1',
  templateUrl: './splitted-costs-table-component-v1.component.html',
  styleUrls: ['./splitted-costs-table-component-v1.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatTableModule,
    MatIconModule,
    MatTooltipModule
  ]
})
export class SplittedCostsTableV1Component {

  public budgetDataSource: MatTableDataSource<SplittedCostTableElementV1> = new MatTableDataSource([]);
  public displayColumns = [];

  @Input()
  private isExport = false;

  get isExportBudget() {
    return this.isExport;
  }

  @Input()
  set isExportBudget(isExport: boolean) {
    this.isExport = isExport;
    if (isExport) {
      this.displayColumns = ['name', 'cost', 'profit', 'expenses', 'commission', 'customDuties', 'total', 'totalEuro'];
    } else {
      this.displayColumns = ['name', 'cost', 'profit', 'expenses', 'commission', 'customDuties', 'total'];
    }
  }

  @Input()
  set summary(newTableData: SplittedCostTableElementV1[] | SplittedCostTableElementV2[]) {
    if (!newTableData) {
      return;
    }
    console.log('updating splitted cost table', newTableData);
    this.budgetDataSource.data = newTableData as SplittedCostTableElementV1[];
  }
}
